import React, { useEffect, useState } from 'react';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';

const MultiSelectCheckAdmin = ({
  optionList,
  setId,
  selectedValue,
  labelKey,
  valueKey
}: {
  optionList: any;
  setId: any;
  selectedValue: any;
  labelKey: string;
  valueKey: string;
}) => {
  const [value, setValue] = useState(null);
  const [arrayValue, setArrayValue] = useState([]);

  const selectMultipleOption = (value: any) => {
    setArrayValue(value);
    setId(value?.map((x: any) => x?.email_id));
  };
  useEffect(() => {
    // console.log(selectedValue,"selectedValue admin");
    setArrayValue(
      optionList?.map((item: any) => {
        if (selectedValue?.includes(item?.email_id)) {
          return item;
        }
      })
    );
  }, []);

  return (
    <Picky
      value={arrayValue}
      options={optionList}
      onChange={selectMultipleOption}
      open={false}
      valueKey={'email_id'}
      labelKey={labelKey}
      multiple={true}
      includeSelectAll={true}
      includeFilter={true}
      dropdownHeight={600}
    />
  );
};

export default MultiSelectCheckAdmin;
